<template>
    <div class="container waterman3">
        <div class="row">
            <div class="col-md-12" style="margin-bottom:15px;">
                <div class="row">
                    <div class="col-md-4 col-sm-12 block_button_1 text-left">
                        <a href="/static/files/General_scope_billing_q321_waterman_2018.pdf" target="_blank" class="btn btn-purple" role="button" aria-pressed="true">Краткое описание функционала 2018</a>
                    </div>
                    <div class="col-md-4 col-sm-12 block_button_1 text-left">
                        <a href="/static/files/gis_exchange.html" target="_blank" class="btn btn-purple" role="button" aria-pressed="true">Система обмена с ГИС ЖКХ (x321)</a>
                    </div>
                </div>
            </div>
            <div class="col-md-12" v-html="content"></div>
            <div class="col-md-12">
                <h6>В связи с 20 летим проекта мы вручили 25 памятных медалей и поговорили с основной группой разработчиков и технологов.</h6>
                <router-link v-for="button in buttons" :key="button.key" class="btn btn-purple" :to="button.path">{{ button.name }}</router-link>
            </div>
            <div class="col-md-12 mt-5">
                <h2 class="text-center">Свидетельство о регистрации программы "ВАТЕРМАН"</h2>
                <img src="/static/img/license/wateman_license.jpg" alt="Свидетельство о регистрации программы ВАТЕРМАН" class="d-block mx-auto img-fluid">
            </div>
        </div>
    </div>
</template>

<script>
    var marked = require("marked")
    marked.setOptions({
        headerIds: false
    });

    import content from '../pages_content/waterman3.md';

    export default {
        name: 'Waterman3',
        data() {
            return {
                content: this.md(content),
                buttons: [
                    { name:"Список 25-ти медалистов проекта", path:"/waterman-20"},
                    { name:"Интервью участников проекта", path:"/interviewWaterman20"}
                ]
            }
        },
        methods: {
            md: function(val){
                return marked(val);
            }
        },

    }
</script>

<style scoped>
    .container {
        margin-top: 115px;
    }
    .block_button_1 {
        text-align: left!important;
    }
    .block_button_2 {
        text-align: right!important;
    }
    @media (max-width: 767px) {
        .block_button_2 {
            text-align: left!important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/Waterman3.vue